<template>
<div>
<div class="card mb-3" :class="{'active-plan':subscriptionIsCurrent && currentSubscription.plan_level == planLevel}">
	<h3 class="card-header text-white" :style="{backgroundColor: headerColor}">
		{{title}}
	</h3>
	<div class="card-body">

		<div class="row">
			<div class="col-4">
				<div v-if="subscriptionIsCurrent && currentSubscription.is_active == 1 && currentSubscription.plan_level == planLevel" 
					class="d-flex flex-column justify-content-between align-items-center"
					style="height: 100%;">
					<div class="badge badge-pill badge-success">Active Plan</div>
					<div class="text-muted">
						Renews on {{formatDate(currentSubscription.expiry)}}
					</div>
					<div>
						<a href="#" class="text-danger" v-on:click.prevent="cancelSubscriptionConfirm">
							<i class="fa fa-ban"></i>
							Cancel Subscription
						</a>
					</div>
				</div>

				<stripe-button
					v-else-if="!subscriptionIsCurrent || currentSubscription.type == 'Trial'"
					:email="$store.userDetails.email"
					:price-cents="priceCents"
					:name="title"
					:description="title"
					:label="stripeButtonText"
					:process-route="$store.apiRoot+'api/Subscription/create?token='+$store.sessionToken">

					<input type="hidden" name="plan" :value="planId">
					<input type="hidden" name="redirect" :value="redirectThankyou">

				</stripe-button>

				<button v-else class="btn btn-primary" v-on:click="crossGrade">
					{{stripeButtonText}}
				</button>
			</div>
			<div class="col-8">
				<h3>${{monthlyPrice}}/month</small></h3>

				<slot></slot>
			</div>
		</div>

	</div>
</div>

<modal-dialog :modal-visible="cancelModalVisible"
	title="Cancel Subscription"
	confirm-button-text="Cancel Subscription"
	button-class="btn-outline-danger"
	:working="working"
	v-on:closeModal="cancelModalVisible = false"
	v-on:confirm="cancelSubscription">

	<p>To cancel your subscription, enter the following 4 digit code into the box below:</p>

	<div class="generated-cancel-code">{{generatedCancelCode}}</div>

	<input type="text" v-model="cancelCode" class="form-control cancel-code-input">

</modal-dialog>

</div>
</template>
<script type="text/javascript">
import StripeButton from "@/components/StripeButton"

import ModalDialog from "@/components/ModalDialog"

export default {
	name: "SubscriptionPackage",
	components: {
		StripeButton,
		ModalDialog
	},
	props: [
		"title",
		"headerColor",
		"monthlyPrice",
		"planId",
		"planLevel",
		"subscriptionIsCurrent",
		"currentSubscription"
	],
	data() {
		return {
			redirectThankyou: "https://"+window.location.hostname+(window.location.port ? ':'+window.location.port: '')+"/settings/tradetraks-subscription",
			cancelModalVisible: false,
			working: false,
			generatedCancelCode: 5342,
			cancelCode: null
		}
	},
	watch: {
		cancelCode() {
			if (this.cancelCode == this.generatedCancelCode)
				this.working = false
			else
				this.working = true
		}
	},
	computed: {
		priceCents() {
			return this.monthlyPrice*100
		},
		stripeButtonText() {
			if (this.currentSubscription.type != 'Trial') {
				if (this.currentSubscription.plan_level > this.planLevel && this.subscriptionIsCurrent)
					return "Downgrade"
				else if (this.currentSubscription.plan_level < this.planLevel && this.subscriptionIsCurrent)
					return "Upgrade"
			}
			
			return "Subscribe"
		}
	},
	methods: {
		crossGrade() {
			let vm = this

			let payload = {
				new_plan_level: this.planLevel
			}

			this.postData("Subscription/change-plan",payload,true).then(response => {
				if (response.success)
					location.reload()
			})
		},
		cancelSubscriptionConfirm() {
			this.generatedCancelCode = this.getRandomInt(1000,9999)
			this.cancelCode = ""
			this.cancelModalVisible = true
			this.working = true
		},
		cancelSubscription() {
			let vm = this

			this.working = true

			this.postData("Subscription/cancel",{},true).then(response => {
				vm.working = false
				if (response.success) {
					vm.$emit("subscriptionChange")
					vm.cancelModalVisible = false
				}
			})
		}
	}
}
</script>

<style type="text/css" scoped>
	.card {
		transition: transform 0.5s;
	}

	.card:hover {
		transform: scale(1.03,1.03);
	}

	.generated-cancel-code {
		text-align: center;
		font-size: 22pt;
		margin-bottom: 20px;
		color: #606060;
	}

	.cancel-code-input {
		font-size: 20pt;
		text-align: center;
		max-width: 150px;
		margin: auto;
	}

	/*.card.active-plan {
		transform: scale(1.1,1.1);
		box-shadow: 0 0 10px 0 #28a745;
	}*/
</style>